export default __webpack_public_path__ + "static/citizens-bank-logo-1_0.png";